/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './ProductReviewUpDownVote.scss';

const UpDownVoteIcon = ({ direction }) => {

	const upDownVoteClass = classNames('ProductReviewUpDownVote__thumb', {
		[`ProductReviewUpDownVote__thumb--${direction}`]: true
	});
	return (
		<svg
			className={upDownVoteClass}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 512 512"
		>
			<g>
				<g>
					<g>
						<path
							d="M495.736,290.773C509.397,282.317,512,269.397,512,260.796c0-22.4-18.253-47.462-42.667-47.462H349.918
							c-4.284-0.051-25.651-1.51-25.651-25.6c0-4.71-3.814-8.533-8.533-8.533s-8.533,3.823-8.533,8.533
							c0,33.749,27.913,42.667,42.667,42.667h119.467c14.182,0,25.6,16.631,25.6,30.396c0,4.437,0,17.946-26.53,20.855
							c-4.506,0.495-7.834,4.42-7.586,8.951c0.239,4.523,3.985,8.064,8.516,8.064c14.114,0,25.6,11.486,25.6,25.6
							s-11.486,25.6-25.6,25.6h-17.067c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533c14.114,0,25.6,11.486,25.6,25.6
							s-11.486,25.6-25.6,25.6h-25.6c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533c8.934,0,17.067,8.132,17.067,17.067
							c0,8.61-8.448,17.067-17.067,17.067h-128c-35.627,0-48.444-7.074-63.292-15.258c-12.553-6.921-26.786-14.763-54.963-18.79
							c-4.668-0.674-8.994,2.577-9.66,7.236c-0.666,4.668,2.569,8.994,7.236,9.66c25.105,3.584,37.325,10.325,49.152,16.845
							c15.497,8.542,31.505,17.374,71.526,17.374h128c17.869,0,34.133-16.273,34.133-34.133c0-6.229-1.775-12.134-4.83-17.229
							c21.794-1.877,38.963-20.224,38.963-42.505c0-10.829-4.062-20.736-10.735-28.271C500.42,358.212,512,342.571,512,324.267
							C512,310.699,505.634,298.59,495.736,290.773z"
						/>
						<path
							d="M76.8,443.733c9.412,0,17.067-7.654,17.067-17.067S86.212,409.6,76.8,409.6c-9.412,0-17.067,7.654-17.067,17.067
							S67.388,443.733,76.8,443.733z"
						/>
						<path
							d="M179.2,247.467c25.353,0,57.429-28.297,74.3-45.167c36.634-36.634,36.634-82.167,36.634-151.1
							c0-5.342,3.191-8.533,8.533-8.533c29.508,0,42.667,13.158,42.667,42.667v102.4c0,4.71,3.814,8.533,8.533,8.533
							s8.533-3.823,8.533-8.533v-102.4c0-39.083-20.659-59.733-59.733-59.733c-14.831,0-25.6,10.769-25.6,25.6
							c0,66.978,0,107.401-31.633,139.034C216.661,215.006,192.811,230.4,179.2,230.4c-4.719,0-8.533,3.823-8.533,8.533
							S174.481,247.467,179.2,247.467z"
						/>
						<path
							d="M145.067,213.333H8.533c-4.719,0-8.533,3.823-8.533,8.533v256c0,4.71,3.814,8.533,8.533,8.533h136.533
							c4.719,0,8.533-3.823,8.533-8.533v-256C153.6,217.156,149.786,213.333,145.067,213.333z M136.533,469.333H17.067V230.4h119.467
							V469.333z"
						/>
					</g>
				</g>
			</g>
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
		</svg>
	);

};

const ProductReviewUpDownVote = ({
	upVotes, downVotes, addUpvote, addDownvote
}) => (
	<div className="ProductReviewUpDownVote">
		<button type="button" className="ProductReviewUpDownVote__upVotes" onClick={addUpvote} data-ugctest="upvotes">
			<UpDownVoteIcon direction="up" />
			{upVotes}
		</button>

		<button
			type="button"
			className="ProductReviewUpDownVote__downVotes"
			onClick={addDownvote}
			data-ugctest="downvotes"
		>
			<UpDownVoteIcon direction="down" />
			{downVotes}
		</button>
	</div>
);

UpDownVoteIcon.propTypes = {
	direction: PropTypes.string.isRequired
};
ProductReviewUpDownVote.defaultProps = {
	upVotes: 0,
	downVotes: 0
};
ProductReviewUpDownVote.propTypes = {
	upVotes: PropTypes.number,
	downVotes: PropTypes.number,
	addUpvote: PropTypes.func.isRequired,
	addDownvote: PropTypes.func.isRequired
};

export default ProductReviewUpDownVote;
